<template>
  <form>
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">{{title}}</h4>
        <p class="category">Complete your profile</p>
      </md-card-header>

      <md-card-content>
        <form novalidate class="md-layout" @submit="checkUser">
        <div class="md-layout">
          <div class= "md-layout-item md-small-size-100 md-size-100" v-if="hasData">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field>
                  <label>Blood Group</label>
                  <md-select v-model="bloodgroup" name="bloodgroup" id="bloodgroup">
                    <md-option :value= "index+1" v-for = "(blood,index) in bloods">{{ blood }}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
             <div style="float: left;color: #AAAAAA !important;font-size: 14px;font-weight: 400;">Height</div>
              <div class="md-layout-item md-small-size-50 md-size-25" style="float: left">
              <md-field>
                <label>Feet</label>
                <md-input v-model="feet" type="number"></md-input>
              </md-field>
              </div>
              <div class="md-layout-item md-small-size-50 md-size-25" style="float: left">
              <md-field>
              <label>Inch</label>
              <md-input v-model="inch" type="number"></md-input>
            </md-field>
              </div>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Weight</label>
                <md-input v-model="weight" type="number"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-datepicker v-model="donateDate"  >
                <label>Last Donation Date</label>
              </md-datepicker>
            </div>
          </div>

          <div class= "md-layout-item md-small-size-100 md-size-100" v-if="hasNoData">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Name</label>
                <md-input v-model="name" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100  md-size-100">
              <label>Gender</label>
              <br/>
              <md-radio v-model="radio" value="1" >Male</md-radio>
              <md-radio v-model="radio" value="2" >Female</md-radio>
            </div>


            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-datepicker v-model="dateOfBirth"  >
                <label>Date of birth</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Upload an image</label>
                <md-file @change="uploadImage" v-model="imageUpload" />
              </md-field>
            </div>
          </div>

          <div class="md-layout-item md-size-100 text-right" v-if="userCreate">
            <md-button class="md-raised md-success" type="submit">Update Profile</md-button>
          </div>
          <div class="md-layout-item md-size-100 text-right" v-if="donorCreate">
            <md-button class="md-raised md-success" type="submit">Be a donor</md-button>
          </div>
        </div>
        </form>
      </md-card-content>
    </md-card>
  </form>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  import fileBase64 from 'vue-file-base64'
  var moment = require('moment');
export default {
  name: 'edit-profile-form',
  mixins: [validationMixin],

  props: {
    dataBackgroundColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      title:'Creating Profile',
      bloods: ['A+','A-','B+','B-','O+','O-','AB+','AB-'],
      bloodgroup:null,
      name: null,
      feet:null,
      inch:null,
      weight: null,
      code: null,
      radio: 1,
      imageUpload: null,
      returnedImage:'',
      convertedImage: '',
      data: '',
      hasProfile: '',
      dateOfBirth: null,
      donateDate:null,
      hasData: false,
      hasNoData: true,
      userCreate: true,
      donorCreate: false
    }
  },
  methods:{
    uploadImage:function(){



      // let image = this.imageUpload.target.files[0]
      console.log(this.imageUpload )
      let image = this.imageUpload
      /*var reader  = new FileReader();
      reader.onloadend = ()=> {
        this.convertedImage = reader.result
        console.log(this.convertedImage)
        if(this.convertedImage !== '') {

        }
      }
      reader.readAsDataURL(file);*/
      let localdata = JSON.parse(localStorage.getItem('user-response'));
      const formData = new FormData()
      formData.append('picture', this.imageUpload.target.files[0])

      let imagePurified = {
        id: localdata.data.user_role.id,
        picture: formData
      }

      let vue = this
      this.$store.dispatch('imageUpload', imagePurified).then(function (response) {
        console.log(response)
        vue.returnedImage = response.data.data
      }).catch(function (err) {
        vue.imageUpload = null
      })

    },
    checkUser: function(){
      if (this.userCreate == true){

          let dashboardData = this.$store.getters.getDataFromDashboardLayout;
          let localdata = JSON.parse(localStorage.getItem('user-response'));
          if (localdata.data.user_role.id === 1) {
            dashboardData.data = true;
            dashboardData.hasProfile = true;
          }
          else {
            dashboardData.hasProfile = true;
            dashboardData.data = false;
          }

          this.dateOfBirth= moment(this.dateOfBirth).format('YYYY-MM-DD');
          console.log(this.dateOfBirth)
          let profileData ={
            name: this.name,
            picture_path: this.returnedImage,
            date_of_birth: this.dateOfBirth,
            gender_id: this.radio
          }

          let vue = this;
          this.$store.dispatch('SaveProfile', profileData).then(function (response) {
            vue.$store.commit('setDataFromDashboardLayout', {data: dashboardData.data, hasProfile: dashboardData.hasProfile});
            let userData = JSON.parse(localStorage.getItem('user-response'))
            userData.data.user_profile= response.data.data;
            localStorage.setItem('user-response',JSON.stringify(userData));
            setTimeout(function () {
              vue.$router.push({name: 'DashboardLayout'})
              location.reload()
            }, 2000 )


          })

      }
      else if (this.donorCreate == true){
        this.donateDate= moment(this.donateDate).format('YYYY-MM-DD');
        let donorData ={
          blood_group_id: JSON.stringify(this.bloodgroup),
          weight: this.weight,
          height: this.feet+'.'+this.inch,
          last_donate: this.donateDate
        }
        let vue = this;
        this.$store.dispatch('DonorCreate', donorData).then(function (response) {
          let userData = JSON.parse(localStorage.getItem('user-response'))
          userData.data.donor_profile= response.data.data;
          localStorage.setItem('user-response',JSON.stringify(userData));
            vue.$router.push({name: 'Profile'})

console.log('donor data',response.data)

        })
      }
    },
/*
    login: function () {

      let dashboardData = this.$store.getters.getDataFromDashboardLayout;
      let localdata = JSON.parse(localStorage.getItem('user-response'));
      if (localdata.data.user_role.id === 1) {
        dashboardData.data = true;
        dashboardData.hasProfile = true;
      }
      else {
        dashboardData.hasProfile = true;
        dashboardData.data = false;
      }

      this.dateOfBirth= moment().format('YYYY-MM-DD');
      console.log(this.returnedImage)

      let profileData ={
        name: this.firstname + ' ' + this.lastname,
        picture_path: this.returnedImage,
        date_of_birth: this.dateOfBirth,
        gender_id: this.radio
      }

      let vue = this;
      this.$store.dispatch('SaveProfile', profileData).then(function (response) {
        vue.$store.commit('setDataFromDashboardLayout', {data: dashboardData.data, hasProfile: dashboardData.hasProfile});
        let userData = JSON.parse(localStorage.getItem('user-response'))
        userData.data.user_profile= response.data.data;
        localStorage.setItem('user-response',JSON.stringify(userData));
        setTimeout(function () {
          vue.$router.push({name: 'DashboardLayout'})
          location.reload()
        }, 2000 )


      })
    }
*/
  },
  beforeMount(){
    let localdata = JSON.parse(localStorage.getItem('user-response'));

   if (localdata.data.user_profile != null) {
        this.hasData = true;
        this.hasNoData =false;
        this.title = 'Be a donor';
        this.userCreate = false;
        this.donorCreate = true
      }
      this.$store.commit('setDataFromDashboardLayout', {data: this.data, hasProfile: this.hasProfile})
    }
}

</script>
<style>
  .md-radio.md-theme-default.md-checked .md-radio-container:after{
    background-color: #43a047 !important;
  }
  .md-datepicker-dialog.md-theme-default .md-datepicker-header{
    background-color: #43a047 !important;
  }
  .md-button.md-primary{
    background-color: #43a047 !important;

  }
  small {
    display: block;
  }
</style>
